// extracted by mini-css-extract-plugin
export default {"Submit":"Submit_Submit__0Zuhk","right":"Submit_right__h6JlF"};